import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import email from './modules/email';
import todo from './modules/todo';
import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

// Porfolio
import blog from './modules/portfolio/blog.js';
import collaboration from './modules/portfolio/collaboration.js';
import gallery from './modules/portfolio/gallery.js';
import publication from './modules/portfolio/publication.js';
import media from './modules/portfolio/media.js';
import recent from './modules/portfolio/recents.js';

// Project Doc
import packages from './modules/quickCV/package.js';
import coupon from './modules/quickCV/coupon.js';
import coin from './modules/quickCV/coin.js';
import payment from './modules/quickCV/payment.js';
import volunteer from './modules/quickCV/volunteer.js';
import subscriber from './modules/quickCV/subscriber.js';
import contact from './modules/quickCV/contact.js';
import dashboard from './modules/quickCV/dashboard.js';
import relief from './modules/quickCV/relief.js';
import label from './modules/quickCV/label.js';
import language from './modules/quickCV/language.js';
import skill from './modules/quickCV/skill.js';
import feedback from './modules/quickCV/feedback.js';
import key from './modules/quickCV/key.js';
import course from './modules/quickCV/course.js';
import partner from './modules/quickCV/partner.js';
import sidebar from './modules/quickCV/sidebar.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},

    mutations: {
        changeLang (state, payload) {
            localStorage.setItem('currentLanguage', payload.id);
            localStorage.setItem('currentLanguageIcon', payload.icon);
            window.location.reload();
        }
    },

    actions: {
        setLang ({ commit }, payload) {
            commit('changeLang', payload);
        }
    },

    modules: {
        alert,
        authentication,
        users,
        layout,
        chat,
        menu,
        products,
        email,
        todo,
        firebase_todo,
        jobs,
        courses,
        common,

        // Portfolio
        blog,
        collaboration,
        gallery,
        publication,
        media,
        recent,

        // QuickCV
        packages,
        coupon,
        coin,
        payment,
        volunteer,
        subscriber,
        contact,
        dashboard,
        relief,
        label,
        language,
        skill,
        feedback,
        key,
        course,
        partner,
        sidebar
    }
});

